import { AnnotationRenderer } from '../AnnotationRenderer';
const LINE_WIDTH_MARKER = 20;
const LINE_WIDTH_OTHER = 8;
const RGB = 255;
export class AnnotationRendererV2 extends AnnotationRenderer {
    render() {
        const context = this.context;
        const width = this.width;
        const height = this.height;
        const annotations = this.annotations;
        this.clear();
        context.lineCap = 'round';
        annotations.forEach((annotation) => {
            if (annotation.points.length > 1) {
                renderPoints(annotation);
            }
        });
        function renderPoints(annotation) {
            const points = annotation.points;
            const pointCount = points.length;
            let point = points[0];
            let x = point[0] * width;
            let y = point[1] * height;
            context.beginPath();
            context.moveTo(x, y);
            for (let i = 1; i < pointCount; i++) {
                point = points[i];
                x = point[0] * width;
                y = point[1] * height;
                context.lineTo(x, y);
            }
            if (annotation.type === 'marker') {
                context.lineWidth = Math.round((LINE_WIDTH_MARKER / 750) * width);
            }
            else {
                context.lineWidth = Math.round((LINE_WIDTH_OTHER / 750) * width);
            }
            const color = [
                annotation.strokeColor.r,
                annotation.strokeColor.g,
                annotation.strokeColor.b,
                annotation.strokeColor.a / RGB,
            ].join(',');
            context.strokeStyle = `rgba(${color}})`;
            context.stroke();
        }
    }
}
//# sourceMappingURL=AnnotationRendererV2.js.map